<script lang="ts">
  import { getStoresContext } from "~/stores";
  export let request_store_key;
  const { reverse_router } = getStoresContext(request_store_key);
  $: href_home = $reverse_router.routePurpose("home page");

  export let url = "";
  export let color = "black";
</script>

{#if url}
  <a href={href_home}>
    <img src={url} alt="logo" class="mr-2" class:filter={color == "white"} />
  </a>
{/if}

<style lang="scss">
  .filter {
    filter: invert(100%);
  }
  img {
    max-width: 250px;
    max-height: 30px;
    @media only screen and (min-width: 576px) {
      max-width: 300px;
      max-height: 35px;
    }
    @media only screen and (min-width: 992px) {
      max-width: 250px;
      max-height: 30px;
    }
    @media only screen and (min-width: 1200px) {
      max-width: 280px;
      max-height: 35px;
    }
    @media only screen and (min-width: 1440px) {
      max-width: 300px;
      max-height: 40px;
    }
  }

  a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }
</style>
